<template>
  <component
    :is="tag"
    v-bind="$attrs"
    v-scroll-to="to"
    :type="type"
    class="anchor font-semibold u-clickable"
  >
    <slot />
  </component>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    tag: {
      type: String,
      default: "button",
    },
    to: {
      type: [String, Object],
      required: true,
    },
  },
  computed: {
    type() {
      if (this.$attrs.type) {
        return this.$attrs.type;
      }

      if (this.tag === "button") {
        return "button";
      }

      return undefined;
    },
  },
};
</script>

<style lang="scss" scoped>
.anchor {
  @include mixin.button-reset();
  color: var.$green-dark;
  transition: var.$transition-default;

  &:hover {
    color: var.$green-hover;
  }
}
</style>
